export default "__VITE_ASSET__73f251c4__"